import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import backendUrl from '../BackendUrl';

const AdminRoute = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Listen for admin token changes (logout, tab change, etc.)
  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const adminToken = localStorage.getItem('adminToken');
        if (!adminToken) throw new Error('No admin token found');
        await axios.get(`${backendUrl}/api/accounts/admin`, {
          headers: {
            Authorization: `Bearer ${adminToken}`,
          },
        });
        setIsAdmin(true);
      } catch (error) {
        setIsAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdmin();

    const handleStorage = () => {
      setIsLoading(true);
      checkAdmin();
    };
    const handleFocus = () => {
      setIsLoading(true);
      checkAdmin();
    };
    const handleAdminChange = () => {
      setIsLoading(true);
      checkAdmin();
    };

    window.addEventListener('storage', handleStorage);
    window.addEventListener('focus', handleFocus);
    window.addEventListener('adminchange', handleAdminChange);

    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('adminchange', handleAdminChange);
    };
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAdmin) {
    return <Navigate to="/not-authorized" replace />;
  }

  return children;
};

export default AdminRoute;